<script>
	import CustomCollapseCard from "src/components/CustomCollapseCard/CustomCollapseCard.svelte";
	import CustomFileInput from "src/components/CustomFileInput/CustomFileInput.svelte";
	import Lightbox from "src/components/Lightbox/Lightbox.svelte";
	import { isLightBoxOpen, imageLightboxIndex } from "src/store/store";
	import { Col } from "@sveltestrap/sveltestrap";

	export let workshopInvoiceFiles = [];
	export let additionalPhotoFiles = [];
	export let additionalMediaFiles = [];
	export let existingWorkshopFiles = [];
	export let existingAdditionalMedia = [];
	export let state = "create"; // possible values: "view", "edit", "create"
	export let caseDetails = {};

	function onWorkshopFilesSelected(e) {
		const newFiles = Array.from(e.target.files);
		$workshopInvoiceFiles.value = [
			...$workshopInvoiceFiles.value,
			...newFiles,
		];
	}

	function onAdditionalFilesSelected(e) {
		const newFiles = Array.from(e.target.files);
		$additionalPhotoFiles.value = [
			...$additionalPhotoFiles.value,
			...newFiles,
		];
	}

	function on1gbFileUploadSelected(e) {
		const newFiles = Array.from(e.target.files);
		$additionalMediaFiles.value = [
			...$additionalMediaFiles.value,
			...newFiles,
		];
	}

	function onRemove1gbFileUpload(idx) {
		$additionalMediaFiles.value.splice(idx, 1);
		$additionalMediaFiles.value = [...$additionalMediaFiles.value];
	}

	function removeWorkshopFile(idx) {
		$workshopInvoiceFiles.value.splice(idx, 1);
		$workshopInvoiceFiles.value = [...$workshopInvoiceFiles.value];
	}
	function removeAdditionalPhoto(idx) {
		$additionalPhotoFiles.value.splice(idx, 1);
		$additionalPhotoFiles.value = [...$additionalPhotoFiles.value];
	}

	function mapFilesToObject(files, canDelete = false) {
		if (files && files.length > 0)
			return files.map((file) => ({
				file,
				canDelete,
			}));
		else return [];
	}
</script>

{#if $isLightBoxOpen}
	<Lightbox
		on:click={() => isLightBoxOpen.set(false)}
		imageShowingIndex={$imageLightboxIndex}
	/>
{/if}
<CustomCollapseCard title="Others" isOpenDefault={true} customClass="mb-4">
	<Col xs={6}>
		<!-- Workshop Quotation -->
		{#if state === "edit" || caseDetails.status === "Quoting"}
			<CustomFileInput
				title="Media"
				fileType="image"
				name="additionalPhotos"
				files={mapFilesToObject(existingAdditionalMedia)}
				handleFileChange={onAdditionalFilesSelected}
				on:remove={({ detail }) => removeAdditionalPhoto(detail.index)}
				isEdit={false}
			/>
			<CustomFileInput
				title="Documents"
				fileType="file"
				name="workshopInvoice"
				files={mapFilesToObject(existingWorkshopFiles)}
				handleFileChange={onWorkshopFilesSelected}
				on:remove={({ detail }) => removeWorkshopFile(detail.index)}
				isEdit={false}
			/>
			<CustomFileInput
				title="Additional Media"
				fileType="media"
				name="additionalMedia"
				files={mapFilesToObject($additionalMediaFiles.value, true)}
				handleFileChange={on1gbFileUploadSelected}
				on:remove={({ detail }) => onRemove1gbFileUpload(detail.index)}
				maxFileSize={1024 * 1024 * 1024}
			/>
			<CustomFileInput
				title="Additional Documents"
				fileType="file"
				name="workshopInvoice"
				files={mapFilesToObject($workshopInvoiceFiles.value, true)}
				handleFileChange={onWorkshopFilesSelected}
				on:remove={({ detail }) => removeWorkshopFile(detail.index)}
			/>
		{:else if state === "view"}
			<CustomFileInput
				title="Additional Media"
				fileType="media"
				name="additionalMedia"
				files={mapFilesToObject(existingAdditionalMedia)}
				handleFileChange={on1gbFileUploadSelected}
				on:remove={({ detail }) => onRemove1gbFileUpload(detail.index)}
				maxFileSize={1024 * 1024 * 1024}
				isEdit={false}
			/>
			<CustomFileInput
				title="Documents"
				fileType="file"
				name="workshopInvoice"
				files={mapFilesToObject(existingWorkshopFiles)}
				handleFileChange={onWorkshopFilesSelected}
				on:remove={({ detail }) => removeWorkshopFile(detail.index)}
				isEdit={false}
			/>
		{:else if state === "create"}
			<CustomFileInput
				title="Additional Media"
				fileType="media"
				name="additionalMedia"
				files={mapFilesToObject($additionalMediaFiles.value, true)}
				handleFileChange={on1gbFileUploadSelected}
				on:remove={({ detail }) => onRemove1gbFileUpload(detail.index)}
				maxFileSize={1024 * 1024 * 1024}
				isRequired={true}
			/>
			<CustomFileInput
				title="Workshop Quotation"
				fileType="file"
				name="workshopInvoice"
				files={mapFilesToObject($workshopInvoiceFiles.value, true)}
				handleFileChange={onWorkshopFilesSelected}
				on:remove={({ detail }) => removeWorkshopFile(detail.index)}
			/>
		{/if}
	</Col>
</CustomCollapseCard>
